import { z } from 'zod';
import { sessionStorageKeys } from '@/constants/sessionStorageKeys';

const lastSeenNumberMapSchema = z.record(z.string(), z.number());

const readMap = (): Record<string, number> => {
  try {
    const raw = sessionStorage.getItem(sessionStorageKeys.lastSeenNumber);
    if (raw == null) return {};
    const result = lastSeenNumberMapSchema.safeParse(JSON.parse(raw));
    return result.success ? result.data : {};
  } catch {
    return {};
  }
};

const writeMap = (map: Record<string, number>) => {
  try {
    sessionStorage.setItem(sessionStorageKeys.lastSeenNumber, JSON.stringify(map));
  } catch {
    // quota / private mode
  }
};

export const readLastSeenNumber = (persistKey: string): number | null => {
  const value = readMap()[persistKey];
  return typeof value === 'number' && Number.isFinite(value) ? value : null;
};

export const writeLastSeenNumber = (persistKey: string, value: number) => {
  const map = readMap();
  map[persistKey] = value;
  writeMap(map);
};

export const clearLastSeenNumber = () => {
  try {
    sessionStorage.removeItem(sessionStorageKeys.lastSeenNumber);
  } catch {
    // quota / private mode
  }
};
